import React from 'react';
import '../../styles/corpoClinico.css';
import NeuroPediatra from '../../img/corpoClinico/neuroAlessandra.jpg';

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico_Pediatra">Corpo Clínico</h2>
      </div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={NeuroPediatra} alt="Alessandra" />
            </div>
            <div className="info-container">
              <h3 className="nome">Alessandra dos Anjos</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Esta área foi reservada para que o(a) profissional possa compartilhar
                suas formações acadêmicas, especializações, abordagens terapêuticas
                e experiências clínicas relevantes.
                Os dados de registro profissional no conselho da categoria são
                verificados e mantidos atualizados pela clínica."
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;